/* Media preview only. Purchase quantities live in yr-mascot-builder. */
if (!customElements.get('yr-mascot-product')) {
  customElements.define('yr-mascot-product', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.thumbs = [...this.querySelectorAll('.yr-mascot-thumb')];
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      this.zoomImage = this.querySelector('[data-zoom]');
      this.stage = this.querySelector('.yr-mascot-zoom-stage');
      this.points = new Map();
      this.resetZoom();
      this.showImage(0);
      this.addEventListener('click', e => {
        const link = e.target.closest('[data-variant-link]');
        if (link && !e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
          e.preventDefault();
          if (link.dataset.variantLink !== this.dataset.variant) this.selectVariant(link.dataset.previewUrl, true);
          else {this.request?.abort();this.removeAttribute('aria-busy');}
          return;
        }
        const thumb = e.target.closest('.yr-mascot-thumb');
        if (thumb) this.showImage(this.thumbs.indexOf(thumb));
        const direction = e.target.closest('[data-direction]');
        if (direction) this.showImage(this.index + Number(direction.dataset.direction));
        if (e.target.closest('.yr-mascot-open')) this.openViewer();
        if (e.target.closest('[data-close]')) this.dialog.close();
        if (e.target.closest('[data-zoom-toggle]')) this.toggleZoom();
      }, opts);
      window.addEventListener('popstate', () => this.selectVariant(location.href, false), opts);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.oldOverflow || '';
        this.querySelector('.yr-mascot-open').focus({ preventScroll: true });
        this.resetZoom();
      }, opts);
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); }, opts);
      this.dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') {e.preventDefault();this.showImage(this.index-1);}
        if (e.key === 'ArrowRight') {e.preventDefault();this.showImage(this.index+1);}
      }, opts);
      const main = this.querySelector('.yr-mascot-open');
      main.addEventListener('touchstart', e => {this.swipeStart = e.touches[0].clientX;}, {...opts, passive:true});
      main.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX-this.swipeStart;
        if (Math.abs(dx)>60) {this.showImage(this.index+(dx<0?1:-1));this.swipedAt=Date.now();}
      }, {...opts, passive:true});
      this.stage.addEventListener('pointerdown', e => {
        this.stage.setPointerCapture(e.pointerId);
        this.points.set(e.pointerId,{x:e.clientX,y:e.clientY});
        this.gestureX=e.clientX; this.gestureY=e.clientY;
        this.panX=this.x;this.panY=this.y;
        if(this.points.size===2){this.startDistance=this.distance();this.startScale=this.scale;}
      }, opts);
      this.stage.addEventListener('pointermove', e => {
        if(!this.points.has(e.pointerId))return;
        this.points.set(e.pointerId,{x:e.clientX,y:e.clientY});
        if(this.points.size===2){this.scale=Math.min(4,Math.max(1,this.startScale*this.distance()/this.startDistance));this.wasPinch=true;}
        else if(this.scale>1){this.x=this.panX+e.clientX-this.gestureX;this.y=this.panY+e.clientY-this.gestureY;}
        this.transform();
      }, opts);
      const end = e => {
        if (!this.points.has(e.pointerId)) return;
        const dx=e.clientX-this.gestureX,dy=e.clientY-this.gestureY;
        if(this.points.size===1&&!this.wasPinch){
          if(this.scale===1&&Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy))this.showImage(this.index+(dx<0?1:-1));
          else if(Math.abs(dx)<10&&Math.abs(dy)<10){if(Date.now()-this.lastTap<300){this.toggleZoom();this.lastTap=0;}else this.lastTap=Date.now();}
        }
        this.points.delete(e.pointerId);
        if(this.points.size===0)this.wasPinch=false;
        else {const p=[...this.points.values()][0];this.gestureX=p.x;this.gestureY=p.y;this.panX=this.x;this.panY=this.y;}
      };
      this.stage.addEventListener('pointerup',end,opts);
      this.stage.addEventListener('pointercancel',()=>{this.points.clear();this.wasPinch=false;},opts);
      this.stage.addEventListener('wheel',e=>{e.preventDefault();this.scale=Math.min(4,Math.max(1,this.scale-e.deltaY*.003));this.transform();},{...opts,passive:false});
    }
    disconnectedCallback(){this.events?.abort();this.request?.abort();if(this.dialog?.open)document.body.style.overflow=this.oldOverflow||'';}
    distance(){const [a,b]=[...this.points.values()];return Math.hypot(a.x-b.x,a.y-b.y);}
    resetZoom(){this.scale=1;this.x=0;this.y=0;if(this.zoomImage)this.transform();}
    toggleZoom(){this.scale=this.scale===1?2.5:1;this.x=0;this.y=0;this.transform();}
    transform(){
      const box=this.stage?.getBoundingClientRect();
      if(box){this.x=Math.max(-box.width*(this.scale-1)/2,Math.min(box.width*(this.scale-1)/2,this.x));this.y=Math.max(-box.height*(this.scale-1)/2,Math.min(box.height*(this.scale-1)/2,this.y));}
      if(this.scale===1){this.x=0;this.y=0;}
      this.zoomImage.style.transform=`translate(${this.x}px,${this.y}px) scale(${this.scale})`;
    }
    showImage(index){
      if(!this.thumbs.length)return;
      this.index=(index+this.thumbs.length)%this.thumbs.length;
      const thumb=this.thumbs[this.index],main=this.querySelector('[data-main]');
      main.src=thumb.dataset.image;main.alt=thumb.dataset.alt;
      this.thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===this.index)));
      this.querySelectorAll('[data-direction]').forEach(b=>b.hidden=this.thumbs.length<2);
      const count=this.querySelector('[data-count]');count.textContent=`${this.index+1} / ${this.thumbs.length}`;count.hidden=this.thumbs.length<2;
      const galleryCount=this.querySelector('[data-gallery-count]');if(galleryCount){galleryCount.textContent=count.textContent;galleryCount.hidden=this.thumbs.length<2;}
      if(this.dialog.open){this.zoomImage.src=thumb.dataset.full;this.zoomImage.alt=thumb.dataset.alt;this.resetZoom();}
    }
    openViewer(){
      if(window.Shopify?.designMode || Date.now()-this.swipedAt<500 || !this.thumbs.length)return;
      this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      this.dialog.showModal();this.showImage(this.index);this.dialog.querySelector('[data-close]').focus();
    }
    async selectVariant(href,push){
      this.request?.abort();this.request=new AbortController();
      const url=new URL(href,location.href),requested=url.searchParams.get('variant');
      // Keep draft/localization parameters from the current ordinary product URL.
      const current=new URL(location.href);
      for(const [key,value] of current.searchParams)if(key!=='variant'&&key!=='section_id')url.searchParams.set(key,value);
      const fetchUrl=new URL(url);fetchUrl.searchParams.set('section_id',this.dataset.section);
      this.setAttribute('aria-busy','true');
      let error=this.querySelector('[data-preview-error]');
      if(!error){error=document.createElement('p');error.dataset.previewError='';error.className='yr-mascot-error';error.setAttribute('role','status');this.querySelector('.yr-mascot-gallery').append(error);}
      error.textContent='';
      try{
        const response=await fetch(fetchUrl,{signal:this.request.signal});
        if(!response.ok)throw new Error('Unable to update this selection. Please try again.');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const next=doc.querySelector('yr-mascot-product');
        if(!next || (requested&&next.dataset.variant!==requested))throw new Error('This preview could not be confirmed. Please try again.');
        // Only media and preview labels change. Never replace the builder or its quantities.
        this.querySelector('.yr-mascot-thumbnails').replaceChildren(...next.querySelector('.yr-mascot-thumbnails').children);
        this.thumbs=[...this.querySelectorAll('.yr-mascot-thumb')];this.showImage(0);
        this.querySelector('.yr-mascot-price').replaceChildren(...next.querySelector('.yr-mascot-price').childNodes);
        this.querySelector('.yr-mascot-selected').textContent=next.querySelector('.yr-mascot-selected').textContent;
        this.dataset.variant=next.dataset.variant;
        this.querySelectorAll('[data-mascot-card]').forEach(card=>{const active=card.dataset.id===this.dataset.variant;card.dataset.preview=String(active);card.querySelector('[data-variant-link]').setAttribute('aria-pressed',String(active));});
        if(push)history.pushState({},'',url);
        this.removeAttribute('aria-busy');
      }catch(error){
        if(error.name==='AbortError')return;
        this.querySelector('[data-preview-error]').textContent=error.message;
        // URL stays on the confirmed old variant on fetch failures.
        if(!push){const safe=new URL(location.href);safe.searchParams.set('variant',this.dataset.variant);history.replaceState({},'',safe);}
        this.removeAttribute('aria-busy');
      }
    }
  });
}
